/**
 * Check if two arrays contain the same items.
 * Items *must* be in the same order.
 *
 *   arraysEqual([1, 2, 3], [3, 2, 1]) // false
 *   arraysEqual([1, 2, 3], [1, 2, 3]) // true
 */
export default (function (arr1, arr2) {
  return arr1.length === arr2.length && arr1.every(function (item, i) {
    return item === arr2[i];
  });
});